import angular from 'angular';
import '../app.constants';
import './resource';

const module = angular.module('whyline.resources.organization-segment', [
  'whyline.resources.resource',
]);

const OrganizationSegmentFactory = ($timeout, $http, API_URL, Resource) => {
  /*@ngInject*/

  const _type = 'organization/:organizationId/segment';

  const _schema = {
    name: {
      lowercase: true,
      max: 128,
      required: true,
      type: String,
    },
    organizationId: {
      required: true,
      type: String,
    },
    tree: [
      {
        _id: {
          required: true,
          type: String,
        },
        type: {
          required: true,
          type: String,
        },
      }
    ],
    type: {
      required: true,
      type: String,
    },
    enabled: {
      required: true,
      type: String,
    },
  };


  const OrganizationSegment = function(data) {
    angular.forEach(_schema, (prop, key) => {
      this[key] = prop.default;
    });

    angular.forEach(data, (prop, key) => {
      this[key] = prop;
    });

    this.enable = (enabled, enableInPlaces) => {
      const promise = $http.put(`${API_URL}${_type}/${this._id}/enable`, {
        enabled,
      });
      promise.then(
        response => {
          const item = response.data;
          $timeout(() => {
            // Cuando halla respuesta, modificar el cache
            OrganizationSegment.UpdateCache(item._id, item, null);
          });
          // Devuelve la respuesta desde el cache.
          return OrganizationSegment.GetOneFromCache('_id', this._id);
        }
      );
      return promise;
    };
  };

  OrganizationSegment.GetSegmentWithTree = segmentId => {
    let url = `${API_URL}${_type}/${segmentId}/organization-sectors`;
    return $http.get(url).then(({ data }) => data);
  };

  OrganizationSegment.prototype = new Resource(_type, _schema, OrganizationSegment);

  Resource.Extend(_type, OrganizationSegment);
 

  //one minute
  const validityTime = 5 * 60 * 1000;
  OrganizationSegment.InitCache(validityTime);

  return OrganizationSegment;
};

module.exports = module.factory('OrganizationSegment', OrganizationSegmentFactory);
